import { DestroyRef, DOCUMENT, inject, Service, signal } from '@angular/core';
import { DESKTOP_MEDIA_QUERY } from '../constants/layout.constant';

/**
 * Whether the app is laid out for desktop — the side menu and mini-wallet beside a
 * centred column — rather than for a phone.
 *
 * Templates switch with `md:` variants; this is for the code that has to know too,
 * such as a page publishing a different header on desktop.
 */
@Service()
export class LayoutService {
	private readonly media = inject(DOCUMENT).defaultView?.matchMedia?.(DESKTOP_MEDIA_QUERY);

	private readonly desktop = signal(this.media?.matches ?? false);
	readonly isDesktop = this.desktop.asReadonly();

	constructor() {
		const media = this.media;
		if (!media) {
			return;
		}

		const onChange = (event: MediaQueryListEvent) => this.desktop.set(event.matches);
		media.addEventListener('change', onChange);
		inject(DestroyRef).onDestroy(() => media.removeEventListener('change', onChange));
	}
}
